<landregistry-report class="landregistry-report">
  <ambita-report-print-toolbar/>
  <report-header/>
  <ambita-landregistry land-registry-part="{ opts.componentsToMount.landRegistryPart }"
                       land-registry-state="{ opts.componentsToMount.landRegistryState }"/>

  <script>
    import './landRegistry.tag';
    import '../common/reportHeader.tag';
    import './order/instantPurchase.tag';
    import { init } from './landRegistryReportController';

    init(this);
  </script>
</landregistry-report>
